import './polyfills'
import 'lazysizes'
import Vue from 'vue'
import store from './store'
import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion'
import SlideUpDown from 'vue-slide-up-down'
import Inquiry from 'hertz-inquiry'

import AnchorLink from './components/AnchorLink'
import BurgerButton from './components/BurgerButton'
import Expander from './components/Expander'
import LanguageSwitcher from './components/LanguageSwitcher'
import RentButton from './components/RentButton'
import SwiperSlider from './components/SwiperSlider'
import Tooltip from './components/Tooltip'
import DeviceMixin from './mixins/device'

import './app.css'

import '@/assets/svg/volvo-wordmark-footer.svg'

Vue.config.productionTip = false

Vue.mixin(DeviceMixin)

Vue.component('BadgerAccordion', BadgerAccordion)
Vue.component('BadgerAccordionItem', BadgerAccordionItem)
Vue.component('SlideUpDown', SlideUpDown)

Vue.component('AnchorLink', AnchorLink)
Vue.component('BurgerButton', BurgerButton)
Vue.component('Expander', Expander)
Vue.component('Inquiry', Inquiry)
Vue.component('LanguageSwitcher', LanguageSwitcher)
Vue.component('RentButton', RentButton)
Vue.component('SwiperSlider', SwiperSlider)
Vue.component('Tooltip', Tooltip)
Vue.component('Stations', () => import(/* webpackChunkName: "stations" */ './components/Stations'))


new Vue({
  el: "#vcr-root",
  store,
  delimiters: ["${", "}"]
})
